<sl-label size="large" i18n>Subscription</sl-label>

<sl-card *ngIf="organization != null">
  <sl-list>
    <sl-list-item>
      <sl-label>
        <span *ngIf="organization.terminated" i18n>Stopped</span>
        <span *ngIf="!organization.terminated" i18n>Active</span>:
        <span i18n>({{numberOfWorkers}} medarbejdere)</span>
      </sl-label>

      <sl-label class="mt-2" size="small" color="dark" multiline>
        {{getPrice()/100 | currency:getCurrency()}}/måned + moms.<br>
        <span *ngIf="!organization.terminated && organization.terminationDate == null">
          <span i18n>Next payment</span>:
          <span i18n>{{organization.subscriptionExpires | date:'shortDate'}}</span>
        </span>
        <span *ngIf="!organization.terminated && organization.terminationDate != null">
          <span i18n>Expires</span>:
          <span i18n>{{organization.terminationDate | date:'shortDate'}}</span>
        </span>
      </sl-label>

      <div slot="suffix">
        <sl-badge class="ml-3" type="warning" *ngIf="organization.trial && !organization.terminated && organization.terminationDate == null" i18n>Free trail</sl-badge>
        <sl-badge class="ml-3" type="warning" *ngIf="!organization.terminated && organization.terminationDate != null" i18n>Cancelled</sl-badge>
        <sl-badge class="ml-3" type="danger" *ngIf="organization.terminated" i18n>Stopped</sl-badge>

        <sl-button class="ml-3" size="small" *ngIf="organization.terminated || organization.terminationDate != null" type="primary"
          [disabled]="loading" (click)="enableSubscription()" i18n>Activate subscription</sl-button>
        <sl-button class="ml-3" size="small" *ngIf="!organization.terminated && organization.terminationDate == null" type="danger"
          [disabled]="loading" (click)="cancelSubscription()" i18n>Stop subscription</sl-button>
      </div>

    </sl-list-item>
  </sl-list>
</sl-card>

<sl-label class="mt-4" i18n>Credit Card</sl-label>
<sl-card *ngIf="organization != null">
  <sl-list>
    <sl-list-item>
      <sl-label *ngIf="organization.subscriptionCardNumber && !changingPaymentInstrument" size="small">
        {{organization.subscriptionCardType}}
        {{organization.subscriptionCardNumber}}
      </sl-label>
      <sl-label *ngIf="!organization.subscriptionCardNumber" i18n>No credit card attached</sl-label>
      <sl-progress *ngIf="changingPaymentInstrument" [percentage]="changingPercentage"></sl-progress>
      <div slot="suffix">
        <!--sl-popover placement="top"-->
          <sl-button (click)="addCard()" slot="trigger" size="small" [disabled]="loading || changingPaymentInstrument">
            <span *ngIf="organization.subscriptionCardNumber" i18n>Update card</span>
            <span *ngIf="!organization.subscriptionCardNumber" i18n>Add card</span>
          </sl-button>
          <!--ws-stripe [organization]="organization" (tokenCreate)="onNewPaymentToken($event)"></ws-stripe-->
        <!--/sl-popover-->

        <sl-button class="ml-3" size="small" type="danger" (click)="removePaymentToken()"
          [disabled]="loading || organization.subscriptionCardNumber == null" i18n>Remove card</sl-button>
      </div>
    </sl-list-item>
  </sl-list>
</sl-card>


<sl-label class="mt-4" i18n>Invoices</sl-label>
<sl-well>
  <sl-list lines="full">
    <sl-list *ngIf="!invoices">
      <sl-skeleton class="m-6" effect="sheen"></sl-skeleton>
    </sl-list>
    <sl-list-item *ngFor="let invoice of invoices">
      <sl-label size="small">{{invoice.date|date}}</sl-label>
      <sl-label size="small" color="medium">{{invoice.total/100 | currency:invoice.currency}}</sl-label>

      <div slot="suffix">
        <sl-badge type="warning" *ngIf="!invoice.paid" i18n>Unpaid</sl-badge>
        <sl-icon-button name="cloud-download" (click)="doDownloadInvoice(invoice)"></sl-icon-button>
      </div>
    </sl-list-item>
  </sl-list>
</sl-well>
